import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { Chart } from '@/components/misc/chart';
import { ChartCard } from '@/componentsv2/charts/ChartCard';
import { dailyChartOptions } from '@/componentsv2/charts/chartOptions';
import { useDailyChannelTotals } from '@/componentsv2/charts/dailyMetrics';
import { toChartSeries } from '@/componentsv2/charts/dailySeries';

type OverviewChannelDailyChartProps = {
  metric: 'sales' | 'orders';
};

const chartCopy = {
  sales: { title: 'Gross Income by Channel', format: 'currency' as const },
  orders: { title: 'Number of Orders by Channel', format: 'count' as const },
};

export const OverviewChannelDailyChart = ({ metric }: OverviewChannelDailyChartProps) => {
  const theme = useTheme();
  const state = useDailyChannelTotals(metric);
  const copy = chartCopy[metric];
  const options = useMemo(() => dailyChartOptions(theme, { format: copy.format }), [copy.format, theme]);
  const series = useMemo(() => (state.status === 'ready' ? toChartSeries(state.series) : []), [state]);

  if (state.status === 'error') {
    return <ChartCard title={copy.title} subheader='Last 30 days' height={240} state='error' message={state.message} onRetry={state.retry} />;
  }
  if (state.status !== 'ready') {
    return <ChartCard title={copy.title} subheader='Last 30 days' height={240} state='loading' />;
  }
  if (!series.length) {
    return <ChartCard title={copy.title} subheader='Last 30 days' height={240} state='empty' />;
  }

  return (
    <ChartCard title={copy.title} subheader='Last 30 days' height={240} state='ready'>
      <Chart height={240} type='line' options={options} series={series} />
    </ChartCard>
  );
};
